/**
 * pathを生成
 * @param route eg. '/shipping/:id'
 * @param array of key value  eg. ['id': 'abcdefg]'
 * @returns string eg. '/shipping/abcdefg'
 */
 export const buildPath = (
  route: string,
  params: Array<{ key: string; value: string }>,
): string => {
  let path = route;
  params.forEach((p) => {
    if (path.includes(`:${p.key}`)) {
      path = path.replace(`:${p.key}`, p.value);
    }
  });

  return path;
};

/**
 * id付きのpathを生成
 * @param route eg. '/shipping/:id'
 * @param id eg. 'abcdefg'
 * @returns string eg. '/shipping/abcdefg'
 */
export const buildPathWithId = (route: string, id: string): string => {
  if (!route.includes(':id')) throw new Error('failed to build path with id');

  return route.replace(':id', id);
};

/**
 * id付きのpathのidより前の部分の文字列を取得
 * @param route eg. '/shipping/:id'
 * @returns string eg. '/shipping'
 */
export const extractBasePath = (route: string): string => {
  if (!route.includes(':id')) throw new Error('failed to extract base path');

  return route.split('/:id')[0];
};
